import { render, staticRenderFns } from "./TransactionTable2.vue?vue&type=template&id=617e848b&scoped=true&"
import script from "./TransactionTable2.vue?vue&type=script&lang=ts&"
export * from "./TransactionTable2.vue?vue&type=script&lang=ts&"
import style0 from "./TransactionTable2.vue?vue&type=style&index=0&id=617e848b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617e848b",
  null
  
)

export default component.exports